export enum RegistriesAccessEnum {
  QREF_TERROR = 'cls_ext_ter',
  QREF_FROMU = 'qref_fromu',
  QREF_CONSOLIDATED = 'cls_un',
  QREF_MVK = 'cls_mvk',
  QREF_OTKAZ = 'qref_otkaz',
  QREF_MSLEAD = 'qref_mslead',
  QREF_MSFOUND = 'qref_msfound',
  QREF_MSADR = 'qref_msadr',
  QREF_FTS = 'qref_fts',
  QREF_NELEGAL = 'qref_nelegal',
  QREF_PASSP = 'qref_passp',
  QREF_INTERNALORG = 'qref_internalorg',
  QREF_281FZ = 'qref_281fz',
  CLS_CTFB_5016 = 'cls_ctfb_5016',
  CLS_CTFB = 'cls_ctfb',
  QREF_RISKGROUP = 'qref_riskgroup',
  QREF_UNWANTED = 'qref_unwanted_foreign',
  QREF_INAGENT = 'qref_foreign_agents'
}

export function getRegistriesAccessList(): Array<string> {
  return Object.values(RegistriesAccessEnum);
}
